module.exports = __webpack_public_path__ + "static/media/prop-70.13ea2700.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/june-5/props/images/prop-70.png
// module id = 627
// module chunks = 0 33 34 35